import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Single source of truth for the PlyEZ brand mark + lockup. Previously the
 * mark was duplicated across SiteHeader, AppShell, SiteFooter and AuthLayout
 * (some using a different /logo.png treatment), which let them drift. Every
 * surface now imports from here, and every clickable lockup navigates home.
 */

export function PlyEZMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className="rounded-md"
    />
  );
}

export function BrandLockup({
  to = '/',
  className = '',
  markSize = 28,
  showWord = true,
}: {
  to?: string;
  className?: string;
  markSize?: number;
  showWord?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Link to={to} className={`flex items-center gap-2 ${className}`.trim()}>
      <PlyEZMark size={markSize} />
      {showWord && (
        <span className="font-display text-lg font-semibold tracking-tight">{t('brand')}</span>
      )}
    </Link>
  );
}
